/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const filePickerTokens = {
  BackgroundColorBaseDefault: '#ffffff',
  BackgroundColorBaseDisabled: '#ebecec',
  BorderStyleBaseDefault: 'dashed',
  BorderStyleBaseHover: 'solid',
  BorderStyleBaseDisabled: 'solid',
  BorderStyleBaseFilled: 'solid',
  BorderStyleBaseKeyboardFocus: 'solid',
  BorderStyleInvalidDefault: 'solid',
  BorderStyleListDefault: 'dotted',
  BorderWidthBaseDefault: '1px',
  BorderWidthInvalidDefault: '1px',
  BorderWidthListDefault: '1px',
  BorderColorBaseDefault: '#c4c4c4',
  BorderColorBaseHover: '#394040',
  BorderColorBaseDisabled: '#ebecec',
  BorderColorBaseKeyboardFocus: '#285da3',
  BorderColorInvalidDefault: '#c41936',
  BorderColorListDefault: '#c4c4c4',
  BorderRadiusBaseDefault: '4px',
  FontSizeBaseDefault: '14px',
  FontColorBaseDisabled: '#a7aaaa',
  OutlineColorBaseKeyboardFocus: '#285da3',
  ShadowColorBaseKeyboardFocus: '#8babd6',
  ShadowColorInvalidKeyboardFocus: '#e9778a',
  ShadowWidthBaseKeyboardFocus: '4px',
  ShadowWidthInvalidKeyboardFocus: '4px',
} as const;
